export const getSwapStatsMock = {
  stats: [
    {
      app: '901cd037-2f28-47af-9a30-33677f34c4a0',
      app_name: '123',
      usdt_amount: '0',
      usdt_fee: '0',
      partner_share: '0',
      swap_successful_count: 0,
      swap_all_counts: 0,
      unique_visits: 0,
    },
    {
      app: '0ddfb8c3-4791-4bf3-8b5a-781c789d94bf',
      app_name: 'Another One',
      usdt_amount: '0',
      usdt_fee: '0',
      partner_share: '0',
      swap_successful_count: 0,
      swap_all_counts: 0,
      unique_visits: 0,
    },
    {
      app: 'd928267d-5adf-4c6b-909a-43d1b8b88a9d',
      app_name: 'Iframe widget',
      usdt_amount: '0',
      usdt_fee: '0',
      partner_share: '0',
      swap_successful_count: 0,
      swap_all_counts: 0,
      unique_visits: 0,
    },
    {
      app: '04129b49-9d0c-4fa6-a7b1-e88b3496ea25',
      app_name: 'Keks',
      usdt_amount: '0',
      usdt_fee: '0',
      partner_share: '0',
      swap_successful_count: 0,
      swap_all_counts: 0,
      unique_visits: 0,
    },
    {
      app: '1c16d3ce-fff1-487b-a1ec-e1980e696301',
      app_name: 'MockWidget',
      usdt_amount: '0',
      usdt_fee: '0',
      partner_share: '0',
      swap_successful_count: 0,
      swap_all_counts: 0,
      unique_visits: 0,
    },
    {
      app: 'f7a7e50f-b3e1-4bbd-8d34-49db427a927c',
      app_name: 'Okak',
      usdt_amount: '0',
      usdt_fee: '0',
      partner_share: '0',
      swap_successful_count: 0,
      swap_all_counts: 0,
      unique_visits: 0,
    },
    {
      app: 'fa0a6b77-8f37-46f9-b5ba-59b3ef0d06d1',
      app_name: 'Widgetttt',
      usdt_amount: '0',
      usdt_fee: '0',
      partner_share: '0',
      swap_successful_count: 0,
      swap_all_counts: 0,
      unique_visits: 0,
    },
  ],
  total: 7,
  total_partner_share: '0',
}
